export interface IFriendlyLink {
  name: string
  url: string
}
export const friendlyLinks: IFriendlyLink[] = [
  {
    name: 'OSS Insight', url: 'https://ossinsight.io/?utm_source=website-zh&utm_medium=referral&utm_campaign=pingcap',
  },
  {
    name: 'TiKV', url: 'https://tikv.org/?utm_source=website-zh&utm_medium=referral&utm_campaign=pingcap',
  },
  {
    name: 'Chaos Mesh',
    url: 'https://chaos-mesh.org/zh/?utm_source=website-zh&utm_medium=referral&utm_campaign=pingcap',
  },
  {
    name: '亚马逊云科技', url: 'https://www.amazonaws.cn/?sc_channel=seo&campaign=partner',
  },
  {
    name: '阿里云心选商城', url: 'https://market.aliyun.com/products/56024006/cmgj00054143.html?utm_source=pingcap&utm_medium=referral&utm_campaign=friendlink#sku=yuncode4814300001',
  },
]
